import { render, staticRenderFns } from "./wait_send.vue?vue&type=template&id=407f2e99&scoped=true"
import script from "./wait_send.vue?vue&type=script&lang=js"
export * from "./wait_send.vue?vue&type=script&lang=js"
import style0 from "./wait_send.vue?vue&type=style&index=0&id=407f2e99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f2e99",
  null
  
)

export default component.exports